module.exports = __webpack_public_path__ + "img/daxinqiye.480d1c35.png";